import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const WorkflowSetup = lazy(() => import('./WorkflowSetup'))

const workflowRoutes = [
    {
        path: '/setup/workflows',
        component: WorkflowSetup,
        auth: authRoleAccess.workflow_setup,
    },
]
 
export default workflowRoutes